/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

/**
 * Module imports.
 */
import { FilterPipeModule } from 'ngx-filter-pipe';
import { DirectivesModule } from '../directives/directives.module';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { ModalModule } from 'ngx-bootstrap/modal';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

/**
 * Component imports.
 */
import { BasicCheckBoxSelectComponent } from './basic-check-box-select/basic-check-box-select.component';
import { CheckBoxSelectCardComponent } from './check-box-select-card/check-box-select-card.component';
import { MultiCheckBoxSelectComponent } from './multi-check-box-select/multi-check-box-select.component';
import { UserProfilePicModule } from '../common/user-pofile-pic/user-profile-pic.module';


@NgModule({
  declarations: [
    BasicCheckBoxSelectComponent,
    CheckBoxSelectCardComponent,
    MultiCheckBoxSelectComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    PerfectScrollbarModule,
    DirectivesModule,
    FilterPipeModule,
    UserProfilePicModule,
    InfiniteScrollModule
  ],
  exports: [
    BasicCheckBoxSelectComponent,
    CheckBoxSelectCardComponent,
    MultiCheckBoxSelectComponent
  ]
})
export class CheckBoxSelectModule { }
